<template>
  <!-- The marketing site's footer (improve-online src/components/Footer.vue),
       on the app's public pages since 5 Oct 2026. Links go to the marketing
       site; it has no cookie settings link because these pages have no cookie
       banner. Own class names, as in SignupNavigation. -->
  <footer class="site-footer">
    <v-container class="site-footer__inner">
      <a :href="site('/homepage')" class="site-footer__logo">
        <img src="/static/brand/footer-logo.png" alt="IMPROVE" />
      </a>
    </v-container>
    <hr class="site-footer__rule" />
    <v-container class="site-footer__inner">
      <v-row>
        <v-col cols="12" sm="6" lg="3">
          <h3 class="site-footer__title">IMPROVE</h3>
          <div class="site-footer__links">
            <a v-for="item in improve" :key="item.path" :href="site(item.path)">{{ item.label }}</a>
          </div>
        </v-col>
        <v-col cols="12" sm="6" lg="3">
          <h3 class="site-footer__title">Company</h3>
          <div class="site-footer__links">
            <a :href="site('/about-us')">Our Story</a>
            <a :href="site('/partner-programme')">Partners</a>
            <a :href="site('/resources')">Resources</a>
            <router-link to="/login">Login</router-link>
            <a :href="partnerUrl">Partner Login</a>
          </div>
          <h3 class="site-footer__title site-footer__title--spaced">Courses</h3>
          <div class="site-footer__links">
            <a v-for="item in courses" :key="item.query" :href="site('/course-library?course=' + item.query)">{{ item.label }}</a>
          </div>
        </v-col>
        <v-col cols="12" sm="6" lg="3">
          <h3 class="site-footer__title">Terms &amp; Policies</h3>
          <div class="site-footer__links">
            <a :href="site('/privacy-policy')">Privacy Policy</a>
            <a :href="site('/eula')">End user license agreement</a>
            <a :href="site('/usage-policy')">Terms of use policy</a>
            <cookie-settings-link></cookie-settings-link>
          </div>
        </v-col>
        <v-col cols="12" sm="6" lg="3">
          <h3 class="site-footer__title">Contact</h3>
          <div class="site-footer__links">
            <a :href="mailto">info@improve.online</a>
          </div>
          <h5 class="site-footer__company">IMPROVE PRODUCTIONS LIMITED</h5>
          <span v-for="line in address" :key="line" class="site-footer__address">{{ line }}</span>
          <a href="https://www.linkedin.com/company/improveonline" target="_blank" rel="noopener" class="site-footer__social">
            <img src="/static/icons/improve-linkedin.png" alt="IMPROVE on LinkedIn" />
          </a>
        </v-col>
      </v-row>
    </v-container>
    <hr class="site-footer__rule" />
    <p class="site-footer__legal">
      © {{ year }} IMPROVE PRODUCTIONS LIMITED | Registered Company Number: 11320233
    </p>
  </footer>
</template>

<script>
import CookieSettingsLink from "@/components/CookieSettingsLink";

const IMPROVE_LINKS = [
  { label: "Solutions", path: "/solutions" },
  { label: "Platform", path: "/features" },
  { label: "Library", path: "/course-library" },
  { label: "Pricing", path: "/pricing" },
  { label: "Stories", path: "/customer-stories" },
  { label: "Leadership Plus", path: "/leadership-plus" },
  { label: "Compare IMPROVE", path: "/compare" },
  { label: "Why Switch", path: "/why-switch" },
  { label: "Contact", path: "/contact" },
  { label: "FAQs", path: "/faq" },
  { label: "Watch the 4-minute demo", path: "/watch-demo" },
  { label: "Experience IMPROVE", path: "/experience" },
  { label: "Buy IMPROVE", path: "/get-started" }
];

const COURSES = [
  { label: "Compliance", query: "Compliance" },
  { label: "People & Relationships", query: "PeopleAndRelationships" },
  { label: "Management & Leadership", query: "ManagementAndLeadershipCourses" },
  { label: "Project Management", query: "ProjectManagementCourses" },
  { label: "Health & Safety", query: "HealthAndSafetyCourses" },
  { label: "IT Skills", query: "ITSkillsCourses" }
];

export default {
  name: "SignupFooter",
  components: { CookieSettingsLink },
  props: {
    frontEndUrl: String,
    partnerUrl: String
  },
  data() {
    return {
      improve: IMPROVE_LINKS,
      courses: COURSES,
      address: ["Space City, Dock", "75 Exploration Drive", "Leicester", "LE4 5NU", "United Kingdom"],
      year: new Date().getFullYear(),
      mailto:
        "mailto:info@improve.online?subject=Customer%20Inquiry&body=Hello%20Improve%20Team,%0A%0AI%20would%20like%20to%20inquire%20about%20..."
    };
  },
  methods: {
    site(path) {
      return (this.frontEndUrl || "") + path;
    }
  }
};
</script>

<style scoped>
.site-footer {
  background: #fff;
  border-top: 1px solid #e6ebf1;
  font-family: "Sora", sans-serif;
  text-align: left;
  padding-top: 24px;
}

.site-footer__inner {
  max-width: 1180px;
}

.site-footer__logo {
  display: flex;
  justify-content: center;
}

.site-footer__logo img {
  width: 280px;
  max-width: 100%;
  height: auto;
}

.site-footer__rule {
  border: 0;
  border-top: 1px solid #e6ebf1;
  margin: 16px 0;
}

.site-footer__title {
  font-size: 18px;
  font-weight: 700;
  color: #002458;
  margin: 8px 0 12px;
}

.site-footer__title--spaced {
  margin-top: 24px;
}

.site-footer__links a {
  display: block;
  font-size: 13px;
  line-height: 32px;
  color: #333;
  text-decoration: none;
}

.site-footer__links a:hover {
  color: #08a0a8;
}

.site-footer__company {
  font-size: 13px;
  font-weight: 700;
  color: #002458;
  margin: 12px 0 4px;
}

.site-footer__address {
  display: block;
  font-size: 13px;
  color: #333;
}

.site-footer__social {
  display: inline-block;
  margin-top: 10px;
}

.site-footer__legal {
  font-size: 11px;
  color: #333;
  text-align: center;
  margin: 0;
  padding: 0 16px 20px;
}

@media (max-width: 1263px) {
  .site-footer {
    text-align: center;
  }
}
</style>
